export const educationData = [
    {
        id: 1,
        institution: 'Wilmington University',
        course: 'Master\'s in Information Systems Technologies',
        startYear: '2022',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Anurag Group Of Institutions',
        course: 'Bachelor of Technology',
        startYear: '2013',
        endYear: '2017'
    },
    
]